// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--qUyA5","loading":"loading--fV0Tw"};